import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

@Component({
    selector: 'app-reach-out-page',
    templateUrl: './reach-out-page.component.html',
    styleUrls: ['./reach-out-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReachOutPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const splide = new Splide( '.splide', {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 2,
      arrows: false,
      pagination: false,
      // direction: "rtl",
      autoScroll: {
        speed: 1,
        pauseOnHover: false,  
      },
      breakpoints: {
        
        480: {
          perPage: 1,
        },
      }
    } );

   
    splide.mount( { AutoScroll } );

  }

}
